<template>
  <div>
    <h5>{{$t('assign')}}</h5>
    <form-textarea :error-only="true" :label="$t('agent')" :model="formModel" attribute="users"
                :errors="formErrors"></form-textarea>
    <form-textarea :error-only="true" :label="$t('managers')" :model="formModel" attribute="managers"
                   :errors="formErrors"></form-textarea>
    <form-select  :error-only="true" :model="formModel" :errors="formErrors" attribute="phoneNumber" :label="$t('campaignPhoneNumber')"
                 :options="numbers" :full-width="true"></form-select>
    <form-input :error-only="true" :label="$t('maxRetry')" :model="formModel" attribute="maxRetry"
                :errors="formErrors"></form-input>
    <form-select :error-only="true" :label="$t('retryDelay')" :options="retryDelayOptions" :model="formModel"
                 attribute="retryDelay" :errors="formErrors" :full-width="true"></form-select>
    <div class="alert-warning alert" v-if="formModel.retryDelay && formModel.retryDelay < 60">
      {{$t('shortRetryDelayAlert')}}
    </div>
    <form-checkbox chk-label="Gọi điện trước 8h và sau 17h" :model="formModel" attribute="overtimeCall" :errors="formErrors" ></form-checkbox>
    <div class="alert-danger alert" v-if="formModel.overtimeCall">
      Lưu ý: Doanh nghiệp tự chịu trách nhiệm trước pháp luật nếu hành động gọi điện trước 8h và sau 17h vi phạm nghị định 91!
    </div>
    <form-checkbox :chk-label="$t('autoReportOk')" :model="formModel" attribute="autoReportOk" :errors="formErrors"></form-checkbox>
    <form-checkbox :chk-label="$t('retrySameUser')" :model="formModel" attribute="retrySameUser" :errors="formErrors"></form-checkbox>
    <form-checkbox :chk-label="$t('autoCreateCustomer')" :model="formModel" attribute="autoCreateCustomer"
                   :errors="formErrors"></form-checkbox>
    <form-checkbox :chk-label="$t('autoCreateOpp')" :model="formModel" attribute="autoCreateOpp" :errors="formErrors"
                   v-if="formModel.autoCreateCustomer"></form-checkbox>
    <form-select :error-only="true" :model="formModel" attribute="oppAssignType" :errors="formErrors"
                 :label="$t('oppAssignType')" v-if="formModel.autoCreateCustomer"
                 :options="oppAssignTypeOptions"></form-select>
    <form-textarea :error-only="true" :label="$t('assignedUsers')" :model="formModel" attribute="assignedUsers"
                   :errors="formErrors" v-if="formModel.autoCreateCustomer && formModel.oppAssignType==='users'"></form-textarea>
    <form-select :error-only="true" :model="formModel" attribute="oppAssignStrategy" :errors="formErrors"
                 :label="$t('oppAssignStrategy')" :options="oppAssignStrategyOptions"
                 v-if="formModel.autoCreateCustomer && ['users','all'].includes(formModel.oppAssignType)">
    </form-select>
    <form-checkbox :chk-label="$t('isAutoNext')" :model="formModel" attribute="isAutoNext" :errors="formErrors" ></form-checkbox>
    <form-checkbox :chk-label="$t('autoEndCall', ['x'])" :model="formModel" attribute="autoEndCall" :errors="formErrors" ></form-checkbox>
    <form-input v-if="formModel.autoEndCall" :label="$t('secondsAutoEndCall')" :model="formModel" attribute="secondsAutoEndCall" :errors="formErrors" type="number"></form-input>
  </div>
</template>

<script>
import CRUD from '@/mixins/CRUD';

export default {
  components: {},
  props: ['campaign'],
  mixins: [CRUD],
  data: function () {
    return {
      service: '/call-campaign',
      numbers: [],
      retryDelayOptions: [
        {value: 5, text: this.$t('min', [5])},
        {value: 10, text: this.$t('min', [10])},
        {value: 15, text: this.$t('min', [15])},
        {value: 30, text: this.$t('min', [30])},
        {value: 60, text: this.$t('hr', [1])},
        {value: 120, text: this.$t('hr', [2])},
        {value: 180, text: this.$t('hr', [3])},
        {value: 240, text: this.$t('hr', [4])},
        {value: 480, text: this.$t('hr', [8])},
        {value: 1440, text: this.$t('hr', [24])},
        {value: 2880, text: this.$t('day', [2])},
        {value: 4320, text: this.$t('day', [3])},
        {value: 5760, text: this.$t('day', [4])},
        {value: 7200, text: this.$t('day', [5])},
        {value: 14400, text: this.$t('day', [10])},
        {value: 21600, text: this.$t('day', [15])},
        {value: 43200, text: this.$t('month', [1])},
        {value: 86400, text: this.$t('month', [2])},
        {value: 129600, text: this.$t('month', [3])},
      ],
      oppAssignTypeOptions: [
        {text: this.$t('assignToUserWhoCall'), value: 'self'},
        {text: this.$t('assignToUser'), value: 'users'},
        {text: this.$t('assignToAll'), value: 'all'},
      ],
      oppAssignStrategyOptions: [
        {text: this.$t('random'), value: 'random'},
        {text: this.$t('agentHasFewestCustomer'), value: 'fewest'},
        {text: this.$t('agentHasFewestNewOpportunity'), value: 'fewestOpp'},
      ],
      groups: [],
      groupLoading: false,
      addUserFromGroupLoading: false,
    }
  },
  watch: {
    formModel: {
      handler: function (val) {
        if (val.users && typeof val.users === 'object') {
          this.formModel.users = val.users.map(item => `${item.name} - ${item.ext}`).join('  |  ');
        }
        if (val.managers && typeof val.managers === 'object') {
          this.formModel.managers = val.managers.map(item => `${item.name} - ${item.ext}`).join('  |  ');
        }
        if (val.assignedUsers && typeof val.assignedUsers === 'object') {
          this.formModel.assignedUsers = val.assignedUsers.map(item => `${item.name} - ${item.ext}`).join('  |  ');
        }
        if (!val.phoneNumber) {
          this.formModel.phoneNumber = null;
        }
      },
      deep: true
    }
  },
  mounted() {
    this.update(this.campaign._id);
    this.$service.get('/phone-number', {params: {client: this.campaign.client._id, outbound: true, page: 1, pageSize: 50}}).then(response => {
      let dummyOptions = [{value: null, text: this.$t('default')}];
      if (response && response.data) {
        response.data.docs.forEach(item => {
          dummyOptions.push({value: item.number, text: item.number})
        });
      }
      this.numbers = dummyOptions;
    })
  },
  i18n: {
    messages: {
      vi: {
        assign: "Phân công",
        managers: "Nhân viên quản lý",
        default: "Mặc định",
        campaignPhoneNumber: "Chọn số điện thoại để dùng riêng cho chiến dịch",
        maxRetry: "Số lần gọi lại khi kết nối thất bại",
        retryDelay: "Nếu kết nối thất bại, gọi lại sau",
        autoReportOk: "Không yêu cầu nhân viên báo cáo (Tự động báo cáo kết quả \"Đồng ý\" cho cuộc gọi kết nối thành công)",
        retrySameUser: "Trường hợp Hẹn gọi lại, phân công lần gọi tiếp theo vẫn cho chính nhân viên đã gọi",
        autoCreateCustomer: "Tự động tạo khách hàng cho cuộc gọi có kết quả Đồng ý",
        autoEndCall: "Tự kết thúc nếu khách không nghe máy sau x giây",
        oppAssignType: "Phân công khách hàng cho",
        secondsAutoEndCall: "Nhập số giây tự động kết thúc nếu khách không nghe máy",
        assignToAll: "Tất cả",
        assignToUser: "Nhân viên được chỉ định",
        assignToUserWhoCall: "Nhân viên gọi",
        assignedUsers: "Phân công cho nhân viên",
        oppAssignStrategy: "Cơ chế phân công",
        random: "Ngẫu nhiên",
        agentHasFewestCustomer: "Phân công cho nhân viên đang phụ trách ít khách nhất",
        agentHasFewestNewOpportunity: "Nhân viên có ít cơ hội mới nhất",
        autoCreateOpp: "Tự động tạo cơ hội bán hàng cho cuộc gọi có kết quả Đồng ý",
        isAutoNext: "Cho phép nhân viên tự động quay số khi gọi",
        shortRetryDelayAlert: "Chú ý: Cài đặt thời gian gọi lại quá ngắn làm tăng nguy cơ một liên hệ có thể bị gọi trùng lặp nhiều lần, dẫn tới trải nghiệm không tốt tới khách hàng",
        day: "{0} ngày",
        month: "{0} ngày",
        min: "{0} phút",
        hr: "{0} giờ",
      },
      en: {
        assign: "Phân công",
        managers: "Nhân viên quản lý",
        default: "Mặc định",
        campaignPhoneNumber: "Chọn số điện thoại để dùng riêng cho chiến dịch",
        maxRetry: "Số lần gọi lại khi kết nối thất bại",
        retryDelay: "Nếu kết nối thất bại, gọi lại sau",
        autoReportOk: "Không yêu cầu nhân viên báo cáo (Tự động báo cáo kết quả \"Đồng ý\" cho cuộc gọi kết nối thành công)",
        retrySameUser: "Trường hợp Hẹn gọi lại, phân công lần gọi tiếp theo vẫn cho chính nhân viên đã gọi",
        autoCreateCustomer: "Tự động tạo khách hàng cho cuộc gọi có kết quả Đồng ý",
        autoEndCall: "Tự kết thúc nếu khách không nghe máy sau x giây",
        oppAssignType: "Phân công khách hàng cho",
        secondsAutoEndCall: "Nhập số giây tự động kết thúc nếu khách không nghe máy",
        assignToAll: "Tất cả",
        assignToUser: "Nhân viên được chỉ định",
        assignToUserWhoCall: "Nhân viên gọi",
        assignedUsers: "Phân công cho nhân viên",
        oppAssignStrategy: "Cơ chế phân công",
        random: "Ngẫu nhiên",
        agentHasFewestCustomer: "Phân công cho nhân viên đang phụ trách ít khách nhất",
        agentHasFewestNewOpportunity: "Nhân viên có ít cơ hội mới nhất",
        autoCreateOpp: "Tự động tạo cơ hội bán hàng cho cuộc gọi có kết quả Đồng ý",
        isAutoNext: "Cho phép nhân viên tự động quay số khi gọi",
        shortRetryDelayAlert: "Chú ý: Cài đặt thời gian gọi lại quá ngắn làm tăng nguy cơ một liên hệ có thể bị gọi trùng lặp nhiều lần, dẫn tới trải nghiệm không tốt tới khách hàng",
        day: "{0} ngày",
        month: "{0} ngày",
        min: "{0} phút",
        hr: "{0} giờ",
      }
    }
  }
}
</script>
